import React from 'react';
export const CategoryName: React.FunctionComponent<{ text: string }> = ({ text }) => {
	return !text.includes('/') ? <>{text}</> : <>{text.replace(/\//g, ' / ')}</>
}

export default CategoryName;
